import React from 'react'
import HeroSection from './HeroSection'

export default () => (
  <HeroSection
    top={
      <div
        style={{
          textAlign: 'center',
          marginTop: 100,
          marginBottom: 100,
          maxWidth: 500,
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        <h2>Bring your banks</h2>
        <p className="description">
          Fund your savings from your checking account into your own savings
          account. We move your savings at the end of each week based on your
          activity.{' '}
        </p>
      </div>
    }
    left={
      <>
        <div>
          <img
            className="screenshot-left"
            src="/images/app/app-screen-5@2x.png"
            alt="list of transfers"
          />
          <div
            className="attach-screenshot-left"
            style={{
              maxWidth: 225,
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <p style={{ fontSize: '10px', lineHeight: '15px' }}>
              Only available for U.S. residents with an active checking and
              savings account with an accredited U.S. bank or credit union.
            </p>
          </div>
        </div>
      </>
    }
    right={
      <div style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: 332 }}>
        <div
          style={{
            marginLeft: 'auto',
            marginRight: 'auto',
            textAlign: 'center'
          }}
        >
          <img
            src="/images/app/notifications/funding-from@2x.png"
            alt="funding from feature"
            style={{ maxWidth: '100%' }}
          />
          <img
            src="/images/app/notifications/save-into@2x.png"
            alt="save into feature"
            style={{ maxWidth: '100%' }}
          />
          <img
            src="/images/app/notifications/for-amount@2x.png"
            alt="daily saving limit"
            style={{ maxWidth: '100%' }}
          />
        </div>

        <div className="security-notice" style={{ marginTop: 32 }}>
          <div className="security-notice-section">
            Your information is encrypted and securely transmitted using SSL.
          </div>
          <div className="security-notice-section border-left">
            <div>Protected with</div>
            <div className="security-notice-bold">Bank Level Security</div>
          </div>
        </div>
      </div>
    }
  />
)
